<template>
  <div class="advanced">
    <div
      v-for="(objectType, index) of arrayAdvancedTypes"
      :key="400 + index"
      class="advanced__type"
      :class="{
        active: numberSelectedType === objectType.id,
        disabled: (objectType.id === 1 && isBestPlays) || (objectType.id === 2 && isBestPlays),
      }"
      @click="onClickType(objectType, (objectType.id === 1 && isBestPlays) || (objectType.id === 2 && isBestPlays))"
    >
      {{ objectType.name }}
    </div>
    <div class="advanced__component">
      <KeepAlive>
        <Component
          :is="stringComponentSelected"
          :available-subcategories="availableSubcategories"
          :main-category="mainCategory"
          :field-sectors="fieldSectors"
          :conditions="conditions"
        />
      </KeepAlive>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MediaPlayerAdvancedFilters',
  components: {
    MediaPlayerSubcategories: () => import('@/components/Sections/MediaPlayer-v3/MediaPlayerSubcategories'),
    MediaPlayerFieldSections: () => import('@/components/Sections/MediaPlayer-v3/MediaPlayerFieldSections'),
    MediaPlayerConditions: () => import('@/components/Sections/MediaPlayer-v3/MediaPlayerConditions'),
  },
  props: {
    actionId: {
      type: Number,
      default: 2,
    },
    availableSubcategories: {
      type: Array,
      default: () => [],
    },
    mainCategory: {
      type: Object,
      default: () => ({
        subcategoryGroups: [],
      }),
    },
    fieldSectors: {
      type: Array,
      default: () => [],
    },
    conditions: {
      type: Object,
      default: () => ({
        arrayLocality: [
          {
            text: 'Local',
            value: 1,
            isSelected: true,
          },
          {
            text: 'Visitante',
            value: 2,
            isSelected: true,
          },
        ],
        arrayTimeSections: [
          {
            text: '1-15',
            value: 1,
            isSelected: true,
          },
          {
            text: '16-30',
            value: 2,
            isSelected: true,
          },
          {
            text: '31-45',
            value: 3,
            isSelected: true,
          },
          {
            text: '46-60',
            value: 4,
            isSelected: true,
          },
          {
            text: '61-75',
            value: 5,
            isSelected: true,
          },
          {
            text: '75-90',
            value: 6,
            isSelected: true,
          },
        ],
      }),
    },
    areSubcategoriesDisabled: {
      type: Boolean,
      default: false,
    },
    isFieldSectionsDisabled: {
      type: Boolean,
      default: false,
    },
    isBestPlays: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      stringComponentSelected: 'MediaPlayerSubcategories',
      numberSelectedType: 1,
      arrayAdvancedTypes: [
        {
          name: 'Subcategorías',
          id: 1,
          componentName: 'MediaPlayerSubcategories',
        },
        {
          name: 'Cancha',
          id: 2,
          componentName: 'MediaPlayerFieldSections',
        },
        {
          name: 'Condiciones',
          id: 3,
          componentName: 'MediaPlayerConditions',
        },
      ],
      mainCategorySelectedBackUp: {},
    };
  },
  watch: {
    // areSubcategoriesDisabled: {
    //   immediate: true,
    //   handler(newValue) {
    //     this.onClickType(this.arrayAdvancedTypes[newValue ? 1 : 0]);
    //   },
    // },
    isBestPlays: {
      immediate: true,
      handler(newValue) {
        this.onClickType(this.arrayAdvancedTypes[newValue ? 2 : 0]);
      },
    },
  },
  methods: {
    onClickType(objectType, booleanIsDisabled) {
      if (booleanIsDisabled) {
        return;
      }
      this.numberSelectedType = objectType.id;
      this.stringComponentSelected = objectType.componentName;
    },
  },
};
</script>

<style scoped lang="scss">
.advanced {
  width: 100%;
  display: grid;
  grid-template-columns: 36% 24% 36%;
  column-gap: 2%;

  &__type {
    width: 100%;
    border-radius: 4px;
    border: solid 1px #132839;
    padding: 10px 10px 8px 10px;
    font-family: Roboto-Regular, sans-serif;
    font-size: 12px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 0.97;
    letter-spacing: -0.12px;
    text-align: center;
    color: #1d220f;
    cursor: pointer;

    &.active {
      background-color: #cbee6b;
    }

    &.disabled {
      opacity: 0.5;
      cursor: default;
    }
  }

  &__component {
    width: 100%;
    margin-top: 0.625em;
    grid-column-start: 1;
    grid-column-end: 4;
  }
}
</style>
